// extracted by mini-css-extract-plugin
export default {"cardControls":"MenuItemAndItemGroupList_cardControls__EV9cr","cardControlsHidden":"MenuItemAndItemGroupList_cardControlsHidden__-2nHS"};